import React from "react";
import { Link, useLocation } from "react-router-dom";
import PageToolbar from "../../Components/PageToolbar.js";
import Button from "../../Components/Button/Button.js";
import { openCommandPalette, useRecentNavItems } from "../../Components/CommandPalette.jsx";

// Never a dead end: say what happened, offer search, recent pages and home.
const Page404 = () => {
    const { pathname } = useLocation();
    const recent = useRecentNavItems();

    return (
        <div className="container py-3" style={{ maxWidth: 640 }}>
            <PageToolbar title="Page not found" />
            <p style={{ color: "var(--ink-body)" }}>
                There is no page at <code>{pathname}</code>. It may have moved, or the link is mistyped.
            </p>
            <div className="d-flex flex-wrap gap-2 mb-4">
                <Button variant="primary" onClick={openCommandPalette}>
                    <i className="bi bi-search" aria-hidden="true" /> Find a page
                </Button>
                <Link to="/" className="btn btn-outline-secondary">Go to Dashboard</Link>
            </div>
            {recent.length > 0 && (
                <>
                    <h6 style={{ color: "var(--ink-muted)" }}>Recently visited</h6>
                    <ul className="ui-menu" style={{ maxWidth: 420 }}>
                        {recent.map((it) => (
                            <li key={it.to}>
                                <Link to={it.to} className="ui-menu-item" style={{ textDecoration: "none" }}>
                                    {it.label}
                                    <span className="ui-menu-sub">{it.trail.join(" › ")}</span>
                                </Link>
                            </li>
                        ))}
                    </ul>
                </>
            )}
        </div>
    );
};

export default Page404;
